/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: mixins.init.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/helpers/mixins/mixins.init.js
 */

import uuid from './uuid'
import env from './env'

export default {uuid, env}

